module.exports = __webpack_public_path__ + "static/media/bikini_image.0d612376.png";